<template>
    <v-dialog 
        v-model="handleDialog" 
        width="600" 
    >
        <v-card color="#F4FEFB" class="text-center">
            <v-card-text class="pt-6 pb-0">
                検証結果を下記メールアドレスに送信します。
            </v-card-text>
            <v-card-text>
                {{ email }}
            </v-card-text>
            <v-card-text>
                署名タイムスタンプ一括検証を実行しますか？
            </v-card-text>
            
            <v-divider></v-divider>
            
            <v-card-actions class="justify-center grey lighten-4 py-4">
                <v-btn 
                    min-width=150
                    class="white--text" 
                    color="blue-grey lighten-1" 
                    large 
                    @click="handleDialog = false"
                >
                    キャンセル
                </v-btn>
                <v-btn 
                    min-width="150px" 
                    class="white--text" 
                    color="red" 
                    large 
                    @click="submit"
                >
                    実行
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        computed: {
            handleDialog: {
                get() {
                    return this.dialog;
                },
                set(value) {
                    this.$emit('update:dialog', value);
                }
            }
        },
        methods: {
            submit: function () {
                axios.post(
                    '/documents/signature-validation/post',
                    {
                        'contract_object_id_list': this.contractObjectIdList
                    }
                ).then(res => {
                    if (res.data.success) {
                        this.$emit("success", res.data.message);
                        this.handleDialog = false;
                    } else {
                        this.$emit("error", res.data.message);
                    }
                }).catch(res => {
                    this.$emit("error", "処理に失敗しました");
                }).finally(() => {
                });
            }
        },
        props: ['dialog', 'email', 'contractObjectIdList']
    };
</script>